import axios from 'axios';
import {clearDataRequest, createOverlay, removeOverlay} from  '../../../plugins/utils';

const state = {
    result: null,
    paginateEl: null,
    lng: {},
    parentVesselsType: [],
    vesselsType: [],
    countries: [],
    langLevels: [],
    currency: [],
    selectedVT: {},
    isLoaded: false,
    dataRequest: {pvt: 0, vt: 0, rank: 0, englishlevel: 0, citizenship: 0},
    items: [],
    ranks: []
};

const getters = {
    lng: state => state.lng,
    countries: state => state.countries,
    ranks: state => state.ranks,
    currency: state => state.currency,
    langLevels: state => state.langLevels,
    parentVesselsType: state=>state.parentVesselsType,
    isLoaded: state=>state.isLoaded,
    selectedVT: state => state.selectedVT,
    dataRequest: state => state.dataRequest,
    vesselsType: state=>state.vesselsType,
    items: state=>state.items,

};

const mutations = {
    setLng: (state, payload) => state.lng = payload,
    setParentVesselsType: (state, payload) => {
        state.parentVesselsType = payload
        state.parentVesselsType = [{id: 0, name: "Select type"}, ...state.parentVesselsType]
    },
    setCountries: (state, payload) => {
        state.countries = payload;
        state.countries = [{id: 0, name: "Select citizenship"}, ...state.countries]
    },
    setRanks: (state, payload) => {
        state.ranks = payload;
        state.ranks = [{id: 0, name: "Select rank"}, ...state.ranks]

    },
    setLangLevels: (state, payload) => {
        state.langLevels = payload;
        state.langLevels[0] = "Select level";
    },
    setCurrency: (state, payload) => state.currency = payload,
    setSelectedVT: (state, payload) => state.selectedVT[payload.key] = payload.val,
    prepareRequest: (state, payload) => state.dataRequest[payload.key] = payload.val,
    setVesselsType: (state, payload) => {
        state.vesselsType = payload;
        state.vesselsType = [{id: 0, name: "Select subtype"}, ...state.vesselsType]

    },
    sendRequest: (state, payload) => {
        if (typeof state.dataRequest.page == 'undefined') {
            state.dataRequest.page = 1;
        }

        state.dataRequest['action'] = 'getFilteredData';
        clearDataRequest(state.dataRequest);
        createOverlay(document.getElementById('result'));

        axios.post(url + '/vacancies', state.dataRequest)
            .then(response => {
                removeOverlay();
                document.getElementById('result').innerHTML = response.data.result;
                document.getElementById('filter-paginate').innerHTML = response.data.paginate;
                document.getElementById('total').innerHTML = response.data.total;
            }).catch(err => removeOverlay());

    },
    clearDataRequest: (state) => state.dataRequest = {},
    assignDataRequest: (state, payload) => state.dataRequest = payload,

};


const actions = {
    setLng: ({commit}, payload) => commit('setLng', payload),
    setParentVesselsType: ({commit}, payload) => commit('setParentVesselsType', payload),
    setCountries: ({commit}, payload) => commit('setCountries', payload),
    setRanks: ({commit}, payload) => commit('setRanks', payload),
    setLangLevels: ({commit}, payload) => commit('setLangLevels', payload),
    setCurrency: ({commit}, payload) => commit('setCurrency', payload),
    setSelectedVT: ({commit}, payload) => commit('setSelectedVT', payload),
    prepareRequest: ({commit}, payload) => {
        if (payload.key != 'page') {
            state.dataRequest.page = 1;
        }
        commit('prepareRequest', payload)
    },
    setVesselsType: ({commit}, payload) => commit('setVesselsType', payload),
    sendRequest: ({commit}, payload) => commit('sendRequest', payload),
    clearDataRequest: ({commit}, payload) => commit('clearDataRequest'),
    assignDataRequest: ({commit}, payload) => commit('assignDataRequest', payload),

};


export default {
    state, getters, mutations, actions
}


// WEBPACK FOOTER //
// ./vue/frontfilter/store/modules/general.js